import script from "./ConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmModal.vue?vue&type=style&index=0&id=2182c4e9&scoped=true&lang=scss"
import "./ConfirmModal.vue?vue&type=style&index=1&id=2182c4e9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2182c4e9"]])

export default __exports__